import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppContext } from '/providers/app-context'
import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/billing-payment-card'
import Menu from '/components/billing/nav-menu'
import PaymentCard from '/components/billing/payment-card'

const BillingPaymentDetails = () => {

  const navigate = useNavigate()
  const { user } = useContext(AppContext)
  
  if (user?.permissions.client_admin) return (
    <PageWrapper title="Billing - Payment Card" HelpText={HelpText} heading="Payment Card" menu={<Menu />}>
      <div className='flex flex-row w-full'>
        <PaymentCard/>
      </div>      
    </PageWrapper>
  )
  else navigate("/")
}

export default BillingPaymentDetails